// extracted by mini-css-extract-plugin
export var scrollArea = "_nb-0";